import { useCallback, useEffect, useState } from 'react';
import { Alert, Col, Container, Image, Navbar, Row } from 'react-bootstrap';
import login_img from '../../assets/images/login-img-new.svg';
import './login.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLocalizedRoutes } from '../../hooks/useLocalizedRoutes';
import 'animate.css';
import { useTranslation } from 'react-i18next';
import { ModalInfoVerify } from './ModalInfoVerify';
import PetroprixLogo from '../../assets/images/petroprix-logo';
import { HelpInfo } from '../ui/HelpInfo';
import axiosApi from '../../axios/axios-api';

export const VerifyEmailScreen = () => {
  const { t } = useTranslation();
  const { getPath } = useLocalizedRoutes();
  const [modalShowInfo, setModalShowInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleShowInfo = () => setModalShowInfo(true);
  const location = useLocation();
  const { email } = location.state || {};
  const navigate = useNavigate();
  const [telefono, setTelefono] = useState(t('ayuda.telefono'));
  const [emailAyuda, setEmailAyuda] = useState(t('ayuda.email'));

  useEffect(() => {
    if (!email) {
      navigate(getPath('login'));
    }
  }, [email, getPath, navigate]);

  const fetchInfoContacto = useCallback(async () => {
    try {
      if (process.env.REACT_APP_URL_API) {
        const response = await axiosApi.get('infoPetroprix', {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        if (response?.data?.code === 200) {
          let data = response.data.data;
          setTelefono(data.telefono);
          setEmailAyuda(data.email_informacion);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchInfoContacto();
  }, []);

  return (
    <>
      <Container className='d-lg-none d-xl-none'>
        <Navbar
          collapseOnSelect
          expand='lg'
          className='menu px-1'
          style={{ display: 'flex' }}
        >
          <Navbar.Brand
            as={Link}
            to={getPath('login')}
            className='d-flex flex-column align-items-start'
          >
            <PetroprixLogo className='d-inline-block align-left login-page-logo' />
            <Col xs={12} lg={{ span: 12, order: 1 }}>
              <h3>
                {t('login.header.h1')}
                {t('login.header.h1.red')}
              </h3>
            </Col>
          </Navbar.Brand>
          <HelpInfo telefono_informacion={telefono} email={emailAyuda} />
        </Navbar>
      </Container>
      <Container className='content-login-page'>
        <Col xs={12} lg={{ span: 11, offset: 1 }}>
          <Container className='login-header-container'>
            <header className='d-none d-lg-block'>
              <PetroprixLogo className='d-inline-block align-left login-page-logo' />
              <Col xs={12} lg={{ span: 12, order: 1 }}>
                <h3>
                  {t('login.header.h1')}
                  {t('login.header.h1.red')}
                </h3>
              </Col>
            </header>
            <HelpInfo
              className={'d-none d-lg-block'}
              telefono_informacion={telefono}
              email={emailAyuda}
            />
          </Container>
        </Col>
        <Container className='login-container py-1'>
          <Row className='content-section login-section'>
            <Col xs={12} lg={{ span: 4, offset: 2, order: 3 }} className='mt-5'>
              <Link to={getPath('login')} className='back-link'>
                {t('ui.back-button')}
              </Link>{' '}
              <h2 className='mt-2 text-center'>{t('verify.h2')}</h2>
              <Alert variant='warning-login'>
                <p className='mb-2'>{t('verify.alert')}</p>
                <span>{t('verify.alert-2')}</span>
              </Alert>
              <p className='verify-text-info mt-4'>
                {t('verify.text.email.info')}
              </p>
              <p className='verify-text-email-data'>{email}</p>
              <p className='verify-text-info mt-3'>
                {t('verify.text.email.no')}
                <span
                  className='verify-text-info-link'
                  onClick={handleShowInfo}
                >
                  {t('verify.text.email.solution')}
                </span>
              </p>
            </Col>
            <Col
              xs={12}
              lg={{ span: 4, offset: 1, order: 3 }}
              className='d-none d-lg-block'
            >
              <Image src={login_img} fluid='true' className='mt-5' />
            </Col>
          </Row>

          <ModalInfoVerify
            show={modalShowInfo}
            onHide={() => setModalShowInfo(false)}
          />
        </Container>
      </Container>
    </>
  );
};
